import {SseNotification} from './sse-notification.model';

export class VideoChatSseNotification extends SseNotification {

  public roomName: string;
  public consultantName: string;

  constructor() {
    super();
  }
}
